export function fmtCost(micros: number): string {
  return `$${(micros / 1_000_000).toFixed(4)}`;
}

export function fmtInt(n: number): string {
  return n.toLocaleString("en-US");
}

export function fmtDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString();
}
